import { render, staticRenderFns } from "./BaseSearchInput.vue?vue&type=template&id=51883859&scoped=true&"
import script from "./BaseSearchInput.vue?vue&type=script&lang=js&"
export * from "./BaseSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseSearchInput.vue?vue&type=style&index=0&id=51883859&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51883859",
  null
  
)

export default component.exports